import { AbstractService } from './AbstractService';
import { NewVehicle } from '../types/NewVehicle';
import { IVehicle } from '../models/Vehicle';
import { UpdateVehicleRequest } from '../types/UpdateVehicleRequestData';

export class VehicleService extends AbstractService {
	/**
	 * Get the vehicles from a user
	 */
	getMyVehicles() {
		return this.client.get<IVehicle[]>('/parking/vehicles');
	}

	/**
	 * Add a vehicle to a user
	 * @returns any Default Response
	 */

	addVehicle(data: NewVehicle) {
		return this.client.post<NewVehicle, IVehicle>('/parking/vehicles', data);
	}

	/**
	 * Update a vehicle from a user
	 * @returns any Default Response
	 */
	editVehicle(vehicleId: string, data: UpdateVehicleRequest) {
		return this.client.put<UpdateVehicleRequest, IVehicle>(
			`/parking/vehicles/${vehicleId}`,
			data,
		);
	}

	/**
	 * Delete a vehicle from a user
	 * @returns void
	 */
	deleteVehicle(vehicleId: string) {
		return this.client.delete<void>(`/parking/vehicles/${vehicleId}`);
	}
}
